import React from "react";
import Icon from "../Icon";
import Modal from "../Modal";
import useTodaysPlanAnnouncement from "./useTodaysPlanAnnouncement";

const AUTO_ADVANCE_MS = 4000;

const PAGES = [
  {
    description: "The dashboard now gets you straight into your routine with fewer clicks. Your features, settings, and stats are exactly where you left them.",
    title: "Meet Today's Plan"
  },
  {
    description: "Click Play and your collections queue up automatically, reviews first.",
    title: "Same routine, fewer clicks"
  },
  {
    description: "Open the plan to reorder your queue, or switch to reviews-only or new-words-only days.",
    title: "You're still in control"
  },
  {
    description: "Scroll down and play any collection on its own, just like you always have.",
    title: "Play anything directly"
  }
];

function AnnouncementPages({ onAcknowledge }) {
  const [pageIndex, setPageIndex] = React.useState(0);
  const [hasUserPaged, setHasUserPaged] = React.useState(false);
  const page = PAGES[pageIndex];

  React.useEffect(() => {
    if(hasUserPaged || pageIndex >= PAGES.length - 1) return undefined;
    const timer = setTimeout(() => setPageIndex(pageIndex + 1), AUTO_ADVANCE_MS);
    return () => clearTimeout(timer);
  }, [hasUserPaged, pageIndex]);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 text-center">
      <Icon name="trophy" style={{ color: "#f4b73b", fontSize: 64 }} type="fa" />
      <span className="label label-success"><Icon name="bolt" type="fa" /> New</span>
      <h4 className="joystix" style={{ margin: 0 }}>{page.title}</h4>
      <p className="text-secondary" style={{ minHeight: 60 }}>{page.description}</p>
      <div className="tw-flex tw-gap-2">
        {PAGES.map((p, index) => (
          <button
            aria-label={`Page ${index + 1}`}
            className={`btn btn-xs ${index === pageIndex ? "btn-success" : "btn-default"}`}
            key={p.title}
            onClick={() => { setHasUserPaged(true); setPageIndex(index); }}
            type="button"
          >
            &nbsp;
          </button>
        ))}
      </div>
      <button className="btn btn-success btn-lg btn-block joystix" data-dismiss="modal" onClick={onAcknowledge} type="button">Let's go!</button>
    </div>
  );
}

export default function TodaysPlanAnnouncement({ accountCreatedAt, isBlocked, username }) {
  const { acknowledge, close, isVisible } = useTodaysPlanAnnouncement({ accountCreatedAt, isBlocked, username });

  if(!isVisible) return null;

  return (
    <Modal onHidden={close} size="small" title="Today's Plan">
      <AnnouncementPages onAcknowledge={acknowledge} />
    </Modal>
  );
}
